/* eslint-disable react/react-in-jsx-scope */
import { Center, Image, Stack, Text, Button, Icon } from '@chakra-ui/react';
import { FaArrowLeft, FaExclamationTriangle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const AccessDeniedPage = () => {
  const navigate = useNavigate();

  return (
    <Center
      h='100vh'
      w='100vw'
      p='20px'
      bgGradient='linear(to-r, gray.100, blue.50)'>
      <Stack
        p='6'
        spacing='6'
        align='center'
        borderRadius='lg'>
        <Icon
          as={FaExclamationTriangle}
          w={10}
          h={10}
          color='red.500'
          mb={4}
        />
        <Text
          fontSize='2xl'
          fontWeight='bold'
          textAlign='center'
          color='gray.700'>
          Maaf, Anda tidak memiliki akses untuk halaman ini
        </Text>
        <Image
          mb={4}
          src='https://deoapp-bucket.s3.ap-southeast-1.amazonaws.com/img-fzl/logo/autopilot.png'
          alt='Autopilot.Id'
          boxSize='150px'
          objectFit='contain'
        />
        <Button
          variant='solid'
          colorScheme='red'
          leftIcon={<FaArrowLeft />}
          onClick={() => navigate(-1)}
          size='lg'
          borderRadius='md'
          boxShadow='md'
          _hover={{ bg: 'red.600', boxShadow: 'lg' }}>
          Kembali
        </Button>
      </Stack>
    </Center>
  );
};

export default AccessDeniedPage;
